import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import { CustomBook } from '../../../components/Book/Book';
import { useLocation, useNavigate } from 'react-router-dom';
import HeaderPage from '../../../components/HeaderPage/HeaderPage';
import { main_color_50 } from '../../../styles/_variables';
import { StateBook } from '../../../models/books';
import useSearchParam from '../../../hooks/useQueryParams';
import Filter, { FilterItem } from '../../../components/Filter/CustomFilter';
import { getClubBookcase } from '../../../service/bookcase';

import styles from './ListBookcase.module.scss'

import { getClubIdByPathname, getClubNameByPathname, getFormattedClubName } from '../../../utils/club';
import useHeader from '../../../hooks/useHeader';

const ListClubBookcase: React.FC = () => {
  const location = useLocation();
  
  const [searchState, setSearchState] = useSearchParam<string, StateBook | ''>('stateBook')
  const navigate = useNavigate()

  // const clubId = useUserStore(state => state.club?.id)

  const clubId = getClubIdByPathname();
  const clubName = getClubNameByPathname();

  const {data: bookcase, isFetching} = useQuery(
    ['club', 'bookcase', searchState],
    () => getClubBookcase(clubId, searchState),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  useHeader({ header: getFormattedClubName(), subheader: 'Estante' });

  const onClickFloatButton = (e) => {
    navigate('/books');
  }

  return (
      <div className={styles.container}>
        <HeaderPage header="Estante" bageColor={main_color_50}/>
        <Filter>
          <FilterItem 
            onClick={e => setSearchState('')} 
            active={searchState === ''}>
              Todos
          </FilterItem>
          <FilterItem 
            onClick={e => setSearchState('read')} 
            active={searchState === 'read'}>
              Lidos
          </FilterItem>
        </Filter> 
        <div className={styles.containerBooks}>
          {bookcase?.map(book => 
            <CustomBook
              bookId={book.bookId}
              key={book.bookId}
            />
          )}
        </div>
      </div>
  )
}

export default ListClubBookcase;